import { useGetUserFondsQuery } from '../graphql/advisor/generates';
import { getGraphQLClient } from '../graphql/graphQLClient';

export const useGetUserFonds = () =>
  useGetUserFondsQuery(getGraphQLClient('advisor'), undefined, {
    select: (userFonds) => ({ fonds: userFonds.user.fonds, etag: userFonds.user.etag }),
  });
